import { Link } from 'react-router-dom';
import { useCallback } from 'react';
import { templates, categories } from '@/mocks/templates';

export default function TemplatesPreview() {
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const previewTemplates = templates.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-4">
            海量精美模板，覆盖全行业
          </h2>
          <p className="text-base text-foreground-600 max-w-2xl mx-auto">
            2000+专业设计师打造的网站模板，涵盖企业、电商、博客、餐饮等各类场景
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 flex-wrap mb-10">
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              onClick={scrollToTop}
              className="px-4 py-2 text-sm rounded-full bg-background-50 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 border border-background-200/70 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-product-shop="">
          {previewTemplates.map((tpl) => (
            <Link
              key={tpl.id}
              to={`/category/${tpl.categorySlug}`}
              onClick={scrollToTop}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={tpl.image}
                  alt={tpl.title}
                  title={`${tpl.title} - 免费在线建站模板`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 text-xs rounded-full bg-accent-100 text-accent-700 mb-3">
                  {tpl.category}
                </span>
                <h3 className="text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {tpl.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {tpl.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/category/all"
            onClick={scrollToTop}
            className="inline-flex items-center gap-2 px-8 py-3 text-sm font-medium rounded-md border border-primary-500 text-primary-500 hover:bg-primary-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            查看全部模板
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}